"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.destinationMappings = void 0;
var facebookPixel_1 = __importDefault(require("./facebookPixel"));
var googleAnalytics_1 = __importDefault(require("./googleAnalytics"));
var segment_1 = __importDefault(require("./segment"));
var amplitude_1 = __importDefault(require("./amplitude"));
exports.destinationMappings = {
    facebookPixel: facebookPixel_1.default,
    googleAnalytics: googleAnalytics_1.default,
    segment: segment_1.default,
    amplitude: amplitude_1.default,
};
